import {Component, OnInit} from "@angular/core";
import {IntegrationAdapterTypeBaseComponent} from "../integration-adapter-type-base.component";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";

@Component({
    selector: 'hc-integration-adapter-full-component',
    templateUrl: 'integration-adapter-type-full.component.html',
    standalone: false
})

export class IntegrationAdapterTypeFullComponent extends IntegrationAdapterTypeBaseComponent implements OnInit {


    navigationItems: NavigationItem[] = [
        {
            label: 'adapterTypeVariable',
            action: 'adapterTypeVariable',
            tooltip: 'Adapter Type Variable',
            icon: 'fa-solid fa-cogs',
            toggleable: false,
            default: true
        },
        {
            label: 'adapterType',
            action: 'adapterType',
            tooltip: 'Adapter Type',
            icon: 'fa fa-info-circle',
            toggleable: false,
            default: false
        },
    ];

    ngOnInit() {
        super.ngOnInit();
    }
}